import {
    FETCH_CUSTOMER_CONTACT_BY_ID,
    FETCH_CUSTOMER_CONTACT_BY_ID_ERROR,
    FETCH_CUSTOMER_CONTACT_BY_ID_SUCCESS,
    FETCH_CUSTOMER_CONTACTS,
    FETCH_CUSTOMER_CONTACTS_ERROR,
    FETCH_CUSTOMER_CONTACTS_SUCCESS,
    CREATE_CUSTOMER_CONTACT, CREATE_CUSTOMER_CONTACT_ERROR, CREATE_CUSTOMER_CONTACT_SUCCESS,
    DELETE_CUSTOMER_CONTACT, DELETE_CUSTOMER_CONTACT_ERROR, DELETE_CUSTOMER_CONTACT_SUCCESS,
    RESTORE_CUSTOMER_CONTACT, RESTORE_CUSTOMER_CONTACT_ERROR, RESTORE_CUSTOMER_CONTACT_SUCCESS,
    UPDATE_CUSTOMER_CONTACT, UPDATE_CUSTOMER_CONTACT_ERROR, UPDATE_CUSTOMER_CONTACT_SUCCESS, CustomerContactActionTypes
} from "../../actions/customers/CustomerContactActions";
import {BasicReducerState} from "../BasicReducerState";
import {Nullable} from "../../models/common/Nullable";
import {
    errorFetchingRequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {CustomerContact} from "../../models/customers/CustomerContact";


export interface CustomerContactState {
    [ key: number ]: BasicReducerState< Nullable< CustomerContact[] >, Nullable< CustomerContact >>
}

export function CustomerContactReducer(
    state: CustomerContactState = {},
    action: CustomerContactActionTypes
) {

    switch( action.type ) {
        case FETCH_CUSTOMER_CONTACTS:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...( state[ action.customerId.rawValue ] ?? { totalEntries: 0 } ),
                    entries: {
                        ...( state[ action.customerId.rawValue ]?.entries ?? { current: null } ),
                        request: startFetchingRequestState()
                    }
                }
            };
        case FETCH_CUSTOMER_CONTACTS_SUCCESS:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...( state[ action.customerId.rawValue ] ?? {} ),
                    totalEntries: action.payload.totalEntries,
                    entries: {
                        current: action.payload.entries,
                        request: successFetchingRequestState()
                    }
                }
            };
        case FETCH_CUSTOMER_CONTACTS_ERROR:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    entries: {
                        ...state[ action.customerId.rawValue ].entries ?? {},
                        request: errorFetchingRequestState( action.error )
                    }
                }
            };
        case FETCH_CUSTOMER_CONTACT_BY_ID:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...( state[ action.customerId.rawValue ] ?? {} ),
                    detailedEntries: {
                        ...( state[ action.customerId.rawValue ].detailedEntries ?? {} ),
                        [ action.contactId.rawValue ]: {
                            entry: null,
                            request: startFetchingRequestState()
                        }
                    }
                }
            };
        case FETCH_CUSTOMER_CONTACT_BY_ID_SUCCESS:
            return {
                ...state,
                [ action.customerContact.customerId.rawValue ]: {
                    ...state[ action.customerContact.customerId.rawValue ] ?? {},
                    detailedEntries: {
                        ...state[ action.customerContact.customerId.rawValue ].detailedEntries ?? {},
                        [ action.customerContact.contactId.rawValue ]: {
                            entry: action.customerContact,
                            request: successFetchingRequestState()
                        }
                    }
                }
            };
        case FETCH_CUSTOMER_CONTACT_BY_ID_ERROR:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    detailedEntries: {
                        ...state[ action.customerId.rawValue ].detailedEntries ?? {},
                        [ action.contactId.rawValue ]: {
                            entry: null,
                            request: errorFetchingRequestState( action.error )
                        }
                    }
                }
            };
        case CREATE_CUSTOMER_CONTACT:
        case UPDATE_CUSTOMER_CONTACT:
        case DELETE_CUSTOMER_CONTACT:
        case RESTORE_CUSTOMER_CONTACT:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    changingRequest: startFetchingRequestState()
                }
            };
        case CREATE_CUSTOMER_CONTACT_SUCCESS:
        case UPDATE_CUSTOMER_CONTACT_SUCCESS:
        case DELETE_CUSTOMER_CONTACT_SUCCESS:
        case RESTORE_CUSTOMER_CONTACT_SUCCESS:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    changingRequest: successFetchingRequestState()
                }
            };
        case CREATE_CUSTOMER_CONTACT_ERROR:
        case UPDATE_CUSTOMER_CONTACT_ERROR:
        case DELETE_CUSTOMER_CONTACT_ERROR:
        case RESTORE_CUSTOMER_CONTACT_ERROR:
            return {
                ...state,
                [ action.customerId.rawValue ]: {
                    ...state[ action.customerId.rawValue ] ?? {},
                    changingRequest: errorFetchingRequestState( action.error )
                }
            };
        default:
            return state;
    }

}